// src/StoryHub.js – thin wrapper around pages/StoryHub
// This ensures backward compatibility with older imports.

import React from "react";
import StoryHubPage from "./pages/StoryHub";

export default function StoryHub(props) {
  return <StoryHubPage {...props} />;
}
